import t from 'tcomb'

import { BEHAVIOR_TYPE } from '../const'

export default t.enums(BEHAVIOR_TYPE, 'BehaviorType')
